import React, { useState } from "react";
import { useAuth } from "../../AuthContext";
import { formatDistanceToNow } from "date-fns";

const Comment = ({ comment, onUpdate, onDelete }) => {
  const { user } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(comment.content);
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  const canModify =
    user &&
    (user.id === comment.author?._id ||
      user.role === "admin" ||
      user.role === "staff");

  const formattedDate = comment.createdAt
    ? formatDistanceToNow(new Date(comment.createdAt), { addSuffix: true })
    : "recently";

  const handleEdit = () => {
    setIsEditing(true);
    setEditedContent(comment.content);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleSaveEdit = () => {
    if (editedContent.trim() && editedContent !== comment.content) {
      onUpdate(comment._id, editedContent);
    }
    setIsEditing(false);
  };

  const handleLike = () => {
    setIsLiked(!isLiked);
    setLikeCount(isLiked ? likeCount - 1 : likeCount + 1);
    // In a real implementation, you would call an API to save the like
  };

  return (
    <div className="comment-card">
      <div className="comment-header">
        <div className="comment-user-info">
          <img
            src={
              comment.author?.profilePicture || "/images/dairls-logo-app.png"
            }
            alt={comment.author?.username || "Anonymous"}
            className="comment-avatar"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/dairls-logo-app.png";
            }}
          />
          <div className="comment-metadata">
            <span className="comment-author">
              {comment.author?.username || "Anonymous"}
            </span>
            <span className="comment-time">{formattedDate}</span>
          </div>
        </div>
        {canModify && (
          <div className="comment-actions">
            {!isEditing && (
              <>
                <button
                  className="icon-button edit-button"
                  onClick={handleEdit}
                >
                  <i className="fas fa-edit"></i>
                </button>
                <button
                  className="icon-button delete-button"
                  onClick={() => onDelete(comment._id)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </>
            )}
          </div>
        )}
      </div>

      <div className="comment-content">
        {isEditing ? (
          <div className="comment-edit-form">
            <textarea
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
              className="comment-edit-textarea"
            />
            <div className="comment-edit-actions">
              <button className="cancel-button" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="save-button" onClick={handleSaveEdit}>
                Save
              </button>
            </div>
          </div>
        ) : (
          <p>{comment.content}</p>
        )}
      </div>

      <div className="comment-footer">
        <button
          className={`like-button ${isLiked ? "liked" : ""}`}
          onClick={handleLike}
        >
          <i className={`${isLiked ? "fas" : "far"} fa-heart`}></i>
          {likeCount > 0 && <span className="like-count">{likeCount}</span>}
        </button>
      </div>
    </div>
  );
};

export default Comment;
